import Search from './Search';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Search.state';

export default connect(mapStateToProps, mapDispatchToProps)(Search);
